"use client";

import React from "react";
import ScheduledShifts from "../../components/ScheduledShifts";
import PageHeader from "../../components/ui/PageHeader";
import { CalendarClock } from "lucide-react";

export default function ScheduledShiftsPage() {
  return (
    <div className="p-4 lg:p-6">
      <PageHeader
        title="Scheduled Shifts"
        description="Manage employee shifts for the week"
        icon={CalendarClock}
        variant="card"
        className="mb-6"
      />
      <ScheduledShifts />
    </div>
  );
}
